"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationV2Client = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("./new.crud.client");
class IntegrationV2Client extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.version = 'v2';
        this.entityPath = 'integrations';
    }
    checkCredentials(projectId, checkCredentialsRequetModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/provider-check-credentials`, checkCredentialsRequetModel);
            return response.payload;
        });
    }
    getVars(projectId, adobeRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/provider-vars`, adobeRequestModel);
            return response.payload;
        });
    }
    getVar(projectId, adobeRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/provider-var`, adobeRequestModel);
            return response.payload;
        });
    }
    getReportSuites(projectId, adobeRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/provider-suites`, adobeRequestModel);
            return response.payload;
        });
    }
    getAccounts(projectId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts`, googleRequestModel);
            return response.payload;
        });
    }
    getAccount(projectId, accountId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}`, googleRequestModel);
            return response.payload;
        });
    }
    getWebProperties(projectId, accountId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}/web-properties`, googleRequestModel);
            return response.payload;
        });
    }
    getWebProperty(projectId, accountId, webPropertyId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}/web-properties/${webPropertyId}`, googleRequestModel);
            return response.payload;
        });
    }
    getViews(projectId, accountId, webPropertyId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}/web-properties/${webPropertyId}/views`, googleRequestModel);
            return response.payload;
        });
    }
    getView(projectId, accountId, webPropertyId, viewId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}/web-properties/${webPropertyId}/views/${viewId}`, googleRequestModel);
            return response.payload;
        });
    }
    getCustomDimensions(projectId, accountId, webPropertyId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}/web-properties/${webPropertyId}/custom-dimensions`, googleRequestModel);
            return response.payload;
        });
    }
    getCustomDimension(projectId, accountId, webPropertyId, customDimensionId, googleRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/accounts/${accountId}/web-properties/${webPropertyId}/custom-dimensions/${customDimensionId}`, googleRequestModel);
            return response.payload;
        });
    }
    getReportSuite(projectId, reportId, adobeRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/provider-suites/${reportId}`, adobeRequestModel);
            return response.payload;
        });
    }
    getSegments(projectId, integrationRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/provider-segments`, integrationRequestModel);
            return response.payload;
        });
    }
    getStatus(projectId, statusRequestModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/status`, statusRequestModel);
            return response.payload;
        });
    }
    delete(integration) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(integration, integration.id);
            yield this.httpDelete(url);
        });
    }
    getSegmentsCount(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/integrations/segments-count`);
            return response.payload;
        });
    }
}
exports.IntegrationV2Client = IntegrationV2Client;
//# sourceMappingURL=integrations.v2.client.js.map